import styled from "styled-components"
import Icon from "components/atoms/Icon"
import { transparentize } from "polished"

const StyledContainer = styled.div`
  position: relative;
  width: 7.3rem;
  height: 4.2rem;
`
const StyledContentContainer = styled.div`
  box-shadow: 0 0.2rem 0.4rem 0
    ${({ theme }) => transparentize(0.88, theme.color.main01)};
  background: ${({ theme }) => theme.color.white};
  transform: translateX(-50%);
  top: 0.8rem;
  position: absolute;
  padding: 0.4rem;
  display: flex;
  flex-direction: column;
  width: auto;

  &:before {
    content: "";
    width: 0;
    height: 0;
    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    position: absolute;
    top: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    border-bottom: 0.5rem solid ${({ theme }) => theme.color.white};
  }
`
const StyledFirstLine = styled.div`
  display: flex;
  align-items: center;
`

const StyledIcon = styled(Icon)`
  min-width: 1.5rem;
  min-height: 1rem;
  fill: ${({ theme }) => theme.color.black};

  * {
    fill: inherit;
  }
`
const StyledDuration = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.xs};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: 1;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.quinary03};
  margin-left: 0.8rem;
  white-space: nowrap;
`
const StyledDistance = styled.span`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: 0.8rem;
  line-height: 1.5;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.color.secondary01};
`

export {
  StyledContainer,
  StyledContentContainer,
  StyledIcon,
  StyledDuration,
  StyledDistance,
  StyledFirstLine,
}
